import React, {Component} from 'react';
import {defaultErrorHandler} from '../../context/context';
import EmailAddresses from '../../libs/react-components-admin/email/email-addresses';

export default class FormNotificationsEmail extends Component {

  constructor(props) {
    super(props);
    let model = props.model;
    if (!model) {
      model = {};
      props.onChange(model);
    }
    this.state = {
      model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model));
  }

  render() {
    return <>
      <div className="mb-3">
        <div className="mb-3">
          <label className="form-label mb-0">Recipients</label>
          <div className="form-text">Upon form submission an email is sent to these email addresses</div>
        </div>
        <EmailAddresses initialModel={this.state.model.recipients}
                        onChange={v => this.updateModel('recipients', v)}
                        sendTestEmailAction={emailAddress => this.props.onSendTestEmail(emailAddress)}
                        errorHandler={defaultErrorHandler}/>
      </div>
      {(this.state.model.recipients || []).length > 0 &&
        <div>
          <div className="mb-3">
            <label htmlFor="notificationsEmailSubject" className="form-label">Subject</label>
            <input id="notificationsEmailSubject" name="notificationsEmailSubject"
                   type="text"
                   className="form-control"
                   value={this.state.model.subject || ''}
                   onChange={e => this.updateModel('subject', e.target.value)}/>
            <div className="form-text">You can use the variables <span className="code">{'{{{formName}}}'}</span>,
              <span className="code">{'{{{time}}}'}</span> or <span className="code">{'{{{values.1}}}'}</span>,
              <span className="code">{'{{{values.2}}}'}</span> etc.
            </div>
          </div>
          <EmailBodyTemplate value={(this.state.model.body || {}).template}
              onValueChange={v => this.updateModel('body', { template: v })}/>
        </div>
      }
    </>;
  }

}

class EmailBodyTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: {
        overrideDefault: false
      },
      propsLoaded: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let value = prevState.value;
    let propsLoaded = prevState.propsLoaded;
    if (nextProps.value && !propsLoaded) {
      value = nextProps.value;
      propsLoaded = true;
    }
    return { ...prevState, value, propsLoaded };
  }

  onValuePropertyChange(key, newValue) {
    this.setState((prevState, props) => {
      const newState = { ...prevState };
      newState.value[key] = newValue;
      props.onValueChange(newState.value);
      return newState;
    });
  }

  render() {
    return <div className="card">
      <div className="card-header">
        <div className="form-check">
          <input type="checkbox"
                 id="formNotificationsEmailOverrideDefault"
                 className="form-check-input"
                 checked={this.state.value.overrideDefault}
                 onChange={e => this.onValuePropertyChange('overrideDefault', e.target.checked)} />
          <label className="form-check-label" htmlFor="formNotificationsEmailOverrideDefault">
            Customize body template
          </label>
        </div>
      </div>
      {this.state.value.overrideDefault &&
        <div className="card-body">
          <div className="mb-3">
            <label htmlFor="notificationsEmailBodyTemplate" className="form-label">Template</label>
            <div className="form-text">You can use <span className="code">{' {{{formName}}}'}</span>,
              <span className="code">{' {{{values.0.value}}}'}</span>,
              <span className="code">{' {{{values.1.value}}}'}</span> etc.<br />
            </div>
            <textarea id="notificationsEmailBodyTemplate" name="notificationsEmailBodyTemplate"
                      className="form-control"
                      style={{ height: '8em' }}
                      value={this.state.value.value || ''}
                      onChange={e => this.onValuePropertyChange('value', e.target.value)}/>
          </div>
        </div>
      }
    </div>
  }

}
